import { Perk } from '@models/membership/Perk'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { PERKS_URL } from '../../utils/urls'

const fetchPerks = (params: TableParams) =>
  SBAPI.FetchPaginated<Perk[]>(PERKS_URL, params)

const fetchPerkById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<Perk>(`${PERKS_URL}/${id}`, params)

const createPerk = (perk: FormData) => SBAPI.Post(PERKS_URL, perk)

const updatePerk = (perk: FormData) =>
  SBAPI.Post(`${PERKS_URL}/${perk.get('id')}`, perk)

const deletePerk = (perk: Perk) => SBAPI.Delete(`${PERKS_URL}/${perk.id}`)

export { createPerk, deletePerk, fetchPerkById, fetchPerks, updatePerk }
